module.exports = __webpack_public_path__ + "static/media/img4.1d8d06a2.jpeg";